import { render, staticRenderFns } from "./userDialog.vue?vue&type=template&id=53b161da&scoped=true"
import script from "./userDialog.vue?vue&type=script&lang=js"
export * from "./userDialog.vue?vue&type=script&lang=js"
import style0 from "./userDialog.vue?vue&type=style&index=0&id=53b161da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b161da",
  null
  
)

export default component.exports